import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from "react-dom";
import React from 'react';
import { useFloating, offset, flip, shift, autoUpdate } from '@floating-ui/react-dom';
import { Transition } from "../transition/Transition";
const duration = 150;
const from = { transform: "translateY(-100%)", opacity: 0 };
const to = { transform: "translateY(0)", opacity: 1 };
const OFFSET = 8;
export const PopOver = (props) => {
    const { visible, referenceElement, children, width, minWidth, onClose, purpose } = props;
    const popperNode = React.Children.only(children);
    // const [popperElement, setPopperElement] = React.useState<HTMLDivElement | null>(null);
    const [popperWidth, setPopperWidth] = React.useState(width);
    const ref = React.useRef(null);
    const { x, y, strategy, refs } = useFloating({
        placement: "bottom-start",
        middleware: [offset(OFFSET), flip(), shift()],
        whileElementsMounted: autoUpdate,
        elements: {
            reference: referenceElement
        }
    });
    const dropdownStyle = {
        width: popperWidth,
        minWidth: minWidth,
        // backgroundColor: "yellow",
        clipPath: `inset(-${OFFSET}px -10px -10px -10px)`,
        zIndex: 2000,
    };
    // React.useLayoutEffect(() => {
    //     reference(referenceElement.current);
    // }, [reference, referenceElement]);
    React.useLayoutEffect(() => {
        if (visible === false)
            return;
        if (referenceElement && width === undefined) {
            setPopperWidth(referenceElement.offsetWidth);
        }
    }, [referenceElement, width, visible]);
    return ReactDOM.createPortal(_jsx(Transition, { from: from, to: to, nodeRef: ref.current, duration: duration, show: visible, onExited: onClose, purpose: purpose, children: _jsx("div", { ref: refs.setFloating, style: { ...dropdownStyle, position: strategy, top: y ?? 0, left: x ?? 0 }, children: React.cloneElement(popperNode, { ref, style: { ...popperNode.props.style } }) }) }), document.activeElement?.closest("dialog") ?? document.body);
};
